import React from 'react';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import Action from '../components/layouts/Action';
import Especialidades from '../components/layouts/Especialidades';
import dataServicesHighlight from '../assets/fake-data/data-services-highlight';

import img1 from '../assets/images/items/montono-01.png';
import img2 from '../assets/images/items/montono-02.png';
import img3 from '../assets/images/items/montono-03.png';
import img4 from '../assets/images/items/montono-04.png';
import img5 from '../assets/images/items/montono-05.png';
import img6 from '../assets/images/items/montono-06.png';
import img7 from '../assets/images/items/montono-07.png';
import img9 from '../assets/images/items/montono-09.png';
import img10 from '../assets/images/items/montono-10.png';

const servicesData = [
    {
        img: img1,
        title: 'Terraza',
        desc: 'Un espacio al aire libre ideal para relajarte, tomar algo refrescante y disfrutar del clima tucumano. Nuestra terraza es el punto de encuentro perfecto para conocer a otros viajeros y compartir anécdotas.'
    },
    {
        img: img2,
        title: 'Pileta',
        desc: 'Refréscate y relájate en nuestra pileta. Perfecta para los días de calor en la ciudad, te invitamos a darte un chapuzón y disfrutar de un momento de tranquilidad.'
    },
    {
        img: img3,
        title: 'Room 1',
        desc: 'Descansa en habitaciones cómodas y equipadas. Pensadas para tu confort y descanso después de un largo día recorriendo la ciudad.'
    },
    {
        img: img4,
        title: 'Desayuno',
        desc: 'Comienza tu día con la mejor energía. Ofrecemos un desayuno completo y delicioso para que salgas a explorar Tucumán con todo el impulso necesario.'
    },
    {
        img: img5,
        title: 'Yoga',
        desc: 'Encuentra tu equilibrio y bienestar. Ofrecemos espacios y momentos dedicados a la práctica de yoga para que te relajes en cuerpo y mente.'
    },
    {
        img: img6,
        title: 'Baños compartidos',
        desc: 'Nuestros baños compartidos son modernos, limpios y están equipados con todo lo que necesitas, garantizando comodidad e higiene durante tu estadía.'
    },
    {
        img: img7,
        title: 'Sala de estar',
        desc: 'Un espacio común acogedor y vibrante. Ideal para leer, trabajar con tu laptop, mirar televisión o simplemente charlar con otros huéspedes.'
    },
    {
        img: img9,
        title: 'Lockers',
        desc: 'Tu seguridad es importante para nosotros. Contamos con lockers individuales para que puedas guardar tus pertenencias valiosas con total tranquilidad.'
    },
    {
        img: img10,
        title: 'Cocina',
        desc: 'Nuestra cocina esta equipada con todo lo necesario para que puedas preparar tus propias comidas.'
    }
];

const SereviciosRodex = () => {
    return (
        <div className='services-page'>
            <Header />

            <section className="tf-section services-list" style={{ padding: '150px 0 100px' }}>
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="block-text text-black center" style={{ marginBottom: '80px' }}>
                                <h1 className="heading-bg" data-aos="fade-in" data-aos-duration="1000"><span>Servicios</span></h1>
                                <h5 className="sub-title mb-10" data-aos="fade-up" data-aos-duration="1000">Nuestros espacios</h5>
                                <h3 className="title mb-28" data-aos="fade-up" data-aos-duration="1000">Todo lo que tenemos <br />para ofrecerte</h3>
                            </div>
                        </div>
                    </div>

                    {
                        servicesData.map((item, index) => (
                            <div className="row align-items-center" style={{ marginBottom: '80px' }} key={index}>
                                <div
                                    className={`col-12 col-md-6 order-1 ${index % 2 === 0 ? 'order-md-1' : 'order-md-2'}`}
                                    data-aos={index % 2 === 0 ? 'fade-right' : 'fade-left'}
                                    data-aos-duration="1000"
                                    style={{ marginBottom: '30px' }}
                                >
                                    <div className="image-service" style={{ borderRadius: '20px', overflow: 'hidden', boxShadow: '0 10px 30px rgba(0,0,0,0.1)' }}>
                                        <img src={item.img} alt={item.title} style={{ width: '100%', height: '400px', objectFit: 'cover' }} />
                                    </div>
                                </div>
                                <div
                                    className={`col-12 col-md-6 order-2 ${index % 2 === 0 ? 'order-md-2' : 'order-md-1'}`}
                                    data-aos={index % 2 === 0 ? 'fade-left' : 'fade-right'}
                                    data-aos-duration="1000"
                                >
                                    <div className="content-service" style={{ padding: '0 30px' }}>
                                        <h3 className="fs-30 mb-20 text-black">{item.title}</h3>
                                        <p className="fs-17 text-black" style={{ lineHeight: '1.8' }}>
                                            {item.desc}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            </section>

            <Especialidades data={dataServicesHighlight} />


            <Action />
            <Footer />
        </div>
    );
}

export default SereviciosRodex;